import React, { Component } from "react";
import Page from '../../Page';
import DocumentMeta from 'react-document-meta';
import TableOfContents from '../../components/TableOfContents/TableOfContents';
import TextFullImage from "../../components/TextFullImage/TextFullImage";
import PageNumber from "../../components/PageNumber/PageNumber";

class ContentPage extends Component {
  componentDidMount(){
    const prevLink = '/appart-me/editie-9/';
    const nextLink = '/appart-me/editie-9/astrael-is-anders-met-ambitie-en-dromen';
    const prevPossible = true;
    const nextPossible = true;
    const isScrollable = false;
    this.props.updatelinks(prevLink, nextLink, prevPossible, nextPossible, isScrollable);
  }

  render() {
    const meta = {
      title: 'Appart Me | Overzicht editie 9 ',
    };
    return (
      <Page>
        <DocumentMeta {...meta}>
        <div className="d-flex align-items-center quote standard-padding pb-0">
              <h3 className="dark-h3">
                Overzicht Editie 9
              </h3>
        </div>
        <TableOfContents />
        <PageNumber pageNumber={2} />
        </DocumentMeta>
      </Page>
    )
  }
}

export default ContentPage;
